export default "__VITE_ASSET__c6d1596d__"